import S3, { UploadResponseReturn } from 'react-aws-s3';

const ID = 'AKIAR3EYJOXMNYND664Y';
const SECRET = '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';
const BUCKET_NAME = 'casa-nova-staging';
const SKIP_AWS_UPLOAD_IN_DEV = process.env.NODE_ENV === 'development';

const realS3Client = new S3({
  bucketName: process.env.REACT_APP_AWS_S3_BUCKET ?? BUCKET_NAME,
  region: 'sa-east-1',
  accessKeyId: process.env.REACT_APP_AWS_S3_ID ?? ID,
  secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET ?? SECRET,
});

function getLocalUploadResponse(file: File, newFileName?: string): UploadResponseReturn {
  const originalName = newFileName || file?.name || 'arquivo-local';
  const safeName = originalName.replace(/[^a-zA-Z0-9._-]/g, '-');
  const key = `local-dev/${Date.now()}-${safeName}`;

  return {
    bucket: 'local-dev',
    key,
    location: `https://quick-local.invalid/${key}`,
    status: 204,
  };
}

// Bypass temporario para fluxo local: evita falha no upload AWS durante testes manuais.
export const S3Client = SKIP_AWS_UPLOAD_IN_DEV
  ? {
      uploadFile: async (file: File, newFileName?: string) => getLocalUploadResponse(file, newFileName),
    }
  : realS3Client;
